<template>
  <modal-template
    ref="modal"
    modal-size="sm"
    title="Detalhes"
    type-modal="view_details_modal"
  >
    <div class="modal-content__main">
      <table class="table mb-0 table-striped">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0" v-for="(th, index) in headers" :key="index">{{th.label}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(tr, indexTr) in body" :key="indexTr">
            <td v-for="(td, index) in tr" :key="index">{{ td }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div slot="actions" class="modal-content__control" >
      <d-button
        type="button"
        @click="close()"
        class="btn btn-sm btn-secondary mr-4"
      >Fechar</d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import ModalTemplate from '_shared/Modal.vue';

export default {
  name: 'view-details-modal',
  props: {
    headers: {
      type: Array,
      default: null,
    },
    body: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  components: {
    ModalTemplate,
  },
  methods: {
    ...mapActions([
      'setToggle',
    ]),
    close() {
      this.setToggle({ type: 'view_details_modal', bool: false });
    },
  },
};
</script>
<style lang="scss">
@media (min-width: 992px) {
  .modal-sm {
      max-width: 550px;
  }
}
</style>
<style lang="scss" scoped>
  .modal-sm {
    p {
      margin-bottom: 0;
    }
  }
.modal-content__control {
  display: flex;
  justify-content: flex-end;
}
</style>
